// What the "Send message" dialog says after a send, and whether it clears the draft. A send in
// which every channel failed keeps the draft (it used to be wiped along with the error).
const LABELS = { email: "email", whatsapp: "WhatsApp", sms: "SMS" };

export function sendOutcome(result, channels, email) {
  if (!result?.results) return { error: "", success: `Message sent to ${email}`, clearDraft: true };
  const failed = Object.entries(result.results)
    .filter(([, r]) => !r.success)
    .map(([ch]) => LABELS[ch] || ch);
  const attempted = Object.keys(result.results).length;
  if (failed.length && failed.length >= attempted) {
    return {
      error: `Nothing was sent: ${failed.join(", ")} failed.`,
      success: "",
      clearDraft: false,
    };
  }
  if (failed.length) {
    return {
      error: `Delivered, but failed on: ${failed.join(", ")}`,
      success: "",
      clearDraft: true,
    };
  }
  return {
    error: "",
    success: `Sent via ${channels.map((c) => LABELS[c] || c).join(", ")} to ${email}`,
    clearDraft: true,
  };
}
